import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/manage_user_account',
  component: Layout,
  redirect: '/manage_user_account/index',
  name: 'ManageUserAccount',
  meta: {
    title: '用户管理',
    i18n: 'route.tabbar',
    icon: 'i-ic:round-tab',
  },
  children: [
    {
      path: 'index',
      name: 'ManageUserAccountIndex',
      component: () => import('@/views/manage_user_account/index.vue'),
      meta: {
        title: '用户管理',
        menu: false,
        breadcrumb: false,
        activeMenu: '/manage_user_account',
      },
    },
  ],
}

export default routes
